export default customElements.define('w-field-day-picker', class extends wealthify.componentBases.FieldSelection {

    constructor () {
        super();

        this.addEventListener('change', this.#applyValueFromInputs);
        this.addEventListener(this.events.ValueChange.name, this.#applyValueToInputs);

        this.onConnectedCallback = () => {
            this.dom.inputcontainer.classList.add(`${this.styleSelector}__input-container`);
            this.validateMin = this.validateMin ?? this.constructor.dayRanges.lowerActual;
            this.validateMax = this.validateMax ?? this.constructor.dayRanges.upperActual;
        };
    }

    // Instance properties


    // Static

    static styleSelector = 'c-field-day-picker';

    static dayRanges = {
        lower: 1,
        lowerActual: 1,
        upper: 31,
        upperActual: 28
    };

    static validationProps = [
        wealthify.FieldValidation.validationPropEnums.Min,
        wealthify.FieldValidation.validationPropEnums.Max,
    ];

    static optionTemplate = `
        <div class='${this.styleSelector}__option'>
            <label class='${this.styleSelector}__option-label'>
                <input class='${this.styleSelector}__option-input' type='radio' data-fieldinput>
            </label>
        </div>
    `;

    // Public

    addFieldInputElement () {
        if (this.dom.inputcontainer.children.length) {
            // Don't allow reinitialisation of options
            return;
        }

        const fragment = document.createDocumentFragment();
        const select = this.#getSelectElementForMobile();

        fragment.appendChild(select);

        this.#options.forEach(option => {
            const item = this.#getRadioItem(option);
            
            if (!this.#isValueOutOfBounds(option.value)) {
                const selectOption = document.createElement('option');

                selectOption.value = option.value;
                selectOption.innerHTML = option.extendedLabel;
    
                select.appendChild(selectOption);
            }

            fragment.appendChild(item);
        });
        
        this.dom.inputcontainer.appendChild(fragment);
    }

    formatFieldInputContent () {
        this.dom.fieldinput.forEach(input => {
            const container = input.parentElement;
            
            if (this.#isValueOutOfBounds(input.value)) {
                input.setAttribute('disabled', true);
                container.classList.add(`${this.styleSelector}__option--disabled`);
            }
        });
    }

    // Private

    get #lower () {
        // Need to check attribute directly in case component not initialised
        const validateMin = this.getAttribute('validate-min') || this.validateMin;

        return validateMin ? validateMin : this.constructor.dayRanges.lowerActual;
    }

    get #upper () {
        // Need to check attribute directly in case component not initialised
        const validateMax = this.getAttribute('validate-max') || this.validateMax;

        return validateMax ? validateMax : this.constructor.dayRanges.upperActual;
    }

    get #options () {
        let options = this.options ?? [];

        if (!this.options) {
            for (let index = this.constructor.dayRanges.lower; index <= this.constructor.dayRanges.upper; index++) {
                options[index] = {
                    label: index,
                    extendedLabel: wealthify.type.date.toOrdinalDay(index),
                    value: index
                };
            }
        }
        
        return options;
    }

    #isValueOutOfBounds (value = this.value) {
        const valueNumber = wealthify.type.number.toNumber(value);

        return valueNumber < this.#lower || valueNumber > this.#upper;
    }

    #applyValueFromInputs (event) {
        this.value = event.target.value;
    }

    #applyValueToInputs () {
        if (this.#isValueOutOfBounds()) {
            this.value = '';
        }

        this.dom.fieldinput.forEach((input) => {
            const isChecked = this.value.toString() === input.value.toString();
            const labelClassListAction = isChecked ? 'add' : 'remove';

            input.checked = isChecked;
            input.parentElement.classList[labelClassListAction](`${this.styleSelector}__option-label--selected`);

            if (isChecked) {
                this.dom.mobileSelect.value = input.value;
            }
        });

        this.dom.mobileSelect.value = this.value;
    }

    #getRadioItem (option) {
        const item = wealthify.dom.fromString(this.constructor.optionTemplate);
        const input = item.querySelector('input');
        const label = item.querySelector('label');

        item.classList.add('u-display__none--mobile');
        
        label.appendChild(document.createTextNode(option.label));
        label.setAttribute('aria-label', option.extendedLabel);
        
        input.value = option.value;
        input.name = `${this.name}-input`;
        input.classList.add('u-display__hidden');

        return item;
    }

    #getSelectElementForMobile () {
        const select = wealthify.dom.fromString(`<select class="${this.styleSelector}__mobile-select"></select>`);
        const defaultOption = wealthify.dom.fromString('<option disabled value>Select an option...</option>');

        select.classList.add('u-display__none--tablet', 'u-display__none--desktop');
        select.appendChild(defaultOption);

        this.dom['mobileSelect'] = select;

        return select;
    }

});